
import React from "react";

const NotFound = () => (
  <div className="not-found">
    <h2>Page non trouvée</h2>
  </div>
);

export default NotFound;